import moment from 'moment';
import React from 'react';

function percent(count, total) {
	const p = Math.round(count / total * 100);
	return !isNaN(p) && isFinite(p) ? p + '%' : '−';
}

function renderOptions({ value }) {
	return !value ? '-' : (
		<div>
			{value.map((o, i) => (
				<div key={i}>{o.label}</div>
			))}
		</div>
	);
}

function renderPeriod(_, { row }) {
	return (
		<div>
			<div>{moment(row.starts_at).format('DD.MM.YY')}</div>
			<div>{moment(row.ends_at).format('DD.MM.YY')}</div>
		</div>
	);
}

function renderOverview(_, { row }) {
	return (
		<span>{row.cap - row.leads} ({percent(row.cap - row.leads, row.cap)})</span>
	);
}

function renderStatus(_, { row }) {
	return (
		<span>{row.status === 'active' ? 'Active' : 'Not active'}</span>
	);
}

function renderActions(_, { row, updateById, removeById }) {
	return (
		<div className='action-list'>
			<a
				className='banners-edit-icon'
				onClick={() => updateById(row.id)}
			/>
			<a
				className='remove-icon'
				onClick={() => {
					if (confirm('Delete product cap?')) {
						removeById(row.id);
					}
				}}
			/>
		</div>
	);
}

export default [
	[
		{
			index: 'id',
			header: {
				title: 'ID'
			},
			column: {}
		},
		{
			index: 'product.label',
			header: {
				title: 'Product'
			},
			column: {}
		},
		{
			index: 'countries',
			header: {
				title: 'Countries'
			},
			column: {
				render: renderOptions
			}
		},
		{
			index: 'period',
			header: {
				title: 'Period'
			},
			column: {
				render: renderPeriod
			}
		},
		{
			index: 'cap',
			header: {
				title: 'Cap'
			},
			column: {}
		},
		{
			index: 'leads',
			header: {
				title: 'Leads'
			},
			column: {}
		},
		{
			index: 'overview',
			header: {
				title: 'Overview'
			},
			column: {
				render: renderOverview
			}
		},
		{
			index: 'status',
			header: {
				title: 'Status'
			},
			column: {
				render: renderStatus
			}
		},
		{
			index: 'actions',
			header: {
				title: 'Actions'
			},
			column: {
				render: renderActions
			}
		}
	]
];



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/product-cap/table-initial-data.js